import { Route } from '@angular/router';
import { Permission } from '../../../models/permission.model';
import { PermissionGuard } from '../../../shared/guards/permission.guard';

export const clientDashboardRoute: Route = {
  path: 'client-dashboard',
  canActivate: [PermissionGuard],
  data: { permissions: [Permission.CLIENT] },
  loadComponent: () =>
    import('./client-dashboard.component').then((c) => c.ClientDashboardComponent),
};
